import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import useAppDispatch from "hooks/useAppDispatch";
import useAppSelector from "hooks/useAppSelector";
import { getSystemInfo } from "features/systemInfo/systemInfoAction";
import type { SystemInfo } from "types/SystemInfo";

const LatestSystemInfo = () => {
  const { t } = useTranslation();
  const { systemInfo } = useAppSelector((state) => state.systemInfo);

  const dispatch = useAppDispatch();
  const fetchSystemInfo = () => dispatch(getSystemInfo());
  const callFetchSystemInfo = useCallback(fetchSystemInfo, [
    dispatch,
    getSystemInfo,
  ]);
  useEffect(() => {
    callFetchSystemInfo();
  }, [callFetchSystemInfo]);

  const [latestSystemInfo, setLatestSystemInfo] = useState<SystemInfo | null>(
    null
  );
  useEffect(() => {
    if (systemInfo.length === 0) return;
    setLatestSystemInfo(systemInfo[0]);
  }, [systemInfo]);

  return latestSystemInfo ? (
    <div className="w-full">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center w-full h-full bg-white rounded-lg shadow-md p-4 space-y-2 lg:space-y-0 lg:space-x-12">
        <h2 className="text-xl font-bold whitespace-nowrap mb-2 lg:mb-0">
          {t("_home._notification")}
        </h2>
        <div className="flex w-full text-lg space-y-1 lg:space-y-0 lg:space-x-2">
          <a
            href="/system"
            className="text-primary flex items-center space-x-2"
          >
            <span>
              {format(new Date(latestSystemInfo.view_start_time), "yyyy.MM.dd")}
            </span>
            <span className="font-semibold">{latestSystemInfo.title}</span>
          </a>
        </div>
      </div>
    </div>
  ) : null;
};

export default LatestSystemInfo;
